import { useMemo } from 'react';

import { Icon } from '@/component/Tool/IconPopover';
import { useAllObjectClassListQuery } from '@/hook';
import { RGBA, VFlex } from '@/package';
import { useLabelingBoxContext } from '@/provider';
import { useTaskFrameStore } from '@/store';
import type { BoxWithLabel } from '@/type';

const TaskLayoutHeaderLabelingCountPanel = () => {
  const { selectedTask } = useTaskFrameStore();
  const { data: enabledLabelItemList } = useAllObjectClassListQuery();
  const { getCurrentBoxList } = useLabelingBoxContext();
  const currentBoxList = getCurrentBoxList();

  const labelList = selectedTask?.extendClass ?? enabledLabelItemList ?? [];

  const boxListByLabel = useMemo(() => {
    const labelMap = labelList.reduce(
      (acc, cur) => ({ ...acc, [cur.id]: true }),
      {} as { [x: string]: boolean },
    );

    const boxListByLabel =
      labelList
        ?.filter(item => labelMap[item.id])
        .reduce(
          (acc, label) => ({
            ...acc,
            [label.id]: [],
          }),
          {} as { [x: string]: (BoxWithLabel & { index: number })[] },
        ) ?? {};

    currentBoxList?.forEach((box, index) => {
      if (!boxListByLabel[box.label]) return;

      boxListByLabel[box.label].push({ ...box, index: index + 1 });
    });

    return boxListByLabel;
  }, [labelList, selectedTask, currentBoxList]);

  return (
    <VFlex className="h-[30px] w-full " justify="center" items="center">
      <VFlex
        className="h-full w-fit rounded-sm bg-primary-500 px-4 py-1"
        gap={1}
      >
        {Object.entries(boxListByLabel).map(([id, boxList], idx, arr) => {
          const icon = enabledLabelItemList?.find(
            item => Number(item.id) === Number(id),
          )?.icon;

          const color = new RGBA(
            enabledLabelItemList?.find(item => +item.id === +id)?.color ??
              '#ffffff',
          ).toString();

          return (
            <VFlex gap={1} items="center" key={id}>
              <VFlex gap={0.25} items="center">
                <Icon data={icon?.data ?? ''} color={color}></Icon>
                <div className="w-5 overflow-visible text-right text-body-lg font-semibold text-white">
                  {boxList.length ?? 0}
                </div>
              </VFlex>

              {idx !== arr.length - 1 && (
                <div className="h-4 w-px bg-gray-500" />
              )}
            </VFlex>
          );
        })}
      </VFlex>
    </VFlex>
  );
};

export default TaskLayoutHeaderLabelingCountPanel;
